import React, { useState } from 'react'
import axios from 'axios'
import socketIOClient from 'socket.io-client'
import QRCode from 'qrcode.react'
import Resizer from 'react-image-file-resizer'
import ReCAPTCHA from 'react-google-recaptcha'
import { analytics } from 'firebase'

import classes from './style.module.css'
import statusCard from '../../../../elements/statusCard'

import config from '../../../../../config/environment'
import Done from '../../../../../images/icon/done.svg'
import Loader from '../../../../../images/icon/loader.svg'
import LoaderWhite from '../../../../../images/icon/loaderWhite.svg'
import NoInfo from '../../../../../images/icon/errorGray.svg'
import Error from '../../../../../images/icon/error.svg'

import store from '../../../../../redux'

import validation from '../../../../elements/ValidationService'
import {
    cardNumberAction,
    cardPhotoAction,
    cardVerifyStatusAction,
    fileInputAction, uploadCardPhotoAction,
    showExampleAction
} from '../../../../../redux/stores/firstScreen/action'

import { strings } from '../../../../../i18n'

const { dispatch, getState } = store
const reCaptchaRef = React.createRef()

const cardNumberInputHandler = async (state, event) => {
    const cardNumber = event.target.value
    const cardData = await checkCardNumber(state, cardNumber)
    dispatch(cardNumberAction(state, cardData))
}

const checkCardNumber = async (state, cardNumber) => {
    if (!cardNumber) { return null }

    if (state.payway.indexOf('VISA_MC') === -1) {
        return {
            number: cardNumber
        }
    }

    if (cardNumber.length !== 16) {
        return { ...state.cardData, number: cardNumber }
    }

    if (!validation('CARD', cardNumber)) {
        return { ...state.cardData, number: cardNumber, status: 'INVALID_CARD_NUMBER' }
    }

    // Check country code
    const { countryCode, scheme } = await getCountryCodeAndScheme(state, cardNumber)
    const exchangeWayInfo = state.allExchangeWays.find(way => way.exchangeWayId === state.equivalentData.exchangeWayId)

    if (exchangeWayInfo.supportedCountriesData && !exchangeWayInfo.skipPaymentDetailsScreen) {

        switch (exchangeWayInfo.supportedCountriesData.type) {
            case 'EQUALS':
                if (!exchangeWayInfo.supportedCountriesData.countryCodes.includes(countryCode)) {
                    return { ...state.cardData, number: cardNumber, status: 'NOT_SUPPORTED_COUNTRY' }
                }
                break

            case 'NOT_EQUALS':
                if (exchangeWayInfo.supportedCountriesData.countryCodes.includes(countryCode)) {
                    return { ...state.cardData, number: cardNumber, status: 'NOT_SUPPORTED_COUNTRY' }
                }
                break

            default:
                alert('Unpredictable supported countries type: ' + exchangeWayInfo.supportedCountriesData.type)
                return
        }
    }

    // Check card verification
    const statusCard = await verifyCard(cardNumber)
    cardSocketOpening(state, cardNumber)

    if (!statusCard) {
        return {
            status: 'NO_INFO',
            number: cardNumber,
            countryCode
        }
    }

    return {
        number: cardNumber,
        countryCode,
        scheme,
        status: statusCard
    }
}

const bin = ['400680', '220038']

const getCountryCodeAndScheme = async (state, cardNumber) => {
    try {

        let response

        cardNumber = cardNumber.split(' ').join('')

        if (state.inCurrency === 'RUB') {
            if (bin.includes(cardNumber.slice(0, 6))) {
                return {
                    countryCode: '643',
                    scheme: ''
                }
            }

            response = await axios.get(`https://api.v3.trustee.deals/coin-cat/bin?bin=${cardNumber.slice(0, 6)}`)
            return {
                countryCode: response.data.countryCode,
                scheme: ''
            }
        }

        response = await axios.get('https://lookup.binlist.net/' + cardNumber)

        return {
            countryCode: response.data.country.numeric,
            scheme: response.data.scheme
        }
    } catch (error) {
        return false
    }
}

const verifyCard = async (cardNumber) => {
    try {
        const response = await axios.get(config.backendUrl + '/payment-details/validation-status?cardNumber=' + cardNumber)
        return response.data.status
    } catch (error) {
        console.log(JSON.stringify(error.response.data))
        return false
    }
}

const cardSocketOpening = (state, cardNumber) => {
    const cardSocket = socketIOClient(config.backendUrl + '?mode=CARD_VERIFICATION&token=' + state.userToken + '&cardNumber=' + cardNumber, { transports: ['websocket'] })

    cardSocket.on('openedCardPhotoPage', () => {
        dispatch(cardPhotoAction(state))
    })

    cardSocket.on('updateCardVerifyStatus', (data) => {
        const newState = getState()
        dispatch(cardVerifyStatusAction(state, newState.firstScreen.cardData, data))
    })
}

const CardVerificationLogo = (props) => {

    const { state } = props

    if (!state.cardData) { return null }

    return (
        <div className={classes.status__logo}>
            {state.cardData.status ? state.cardData.status === 'SUCCESS' ?
                <img src={Done} alt={'done'} height={40} />
                : state.cardData.status === 'PENDING' ?
                    <img src={Loader} alt={'load'} height={40} /> :
                    state.cardData.status === 'WAIT_FOR_PHOTO' || state.cardData.status === 'NO_INFO' ? <img src={NoInfo} alt={'no_info'} height={40} />
                        : <img src={Error} alt={'error'} height={40} /> : null}
        </div>
    )
}

const showExampleHandler = () => {
    dispatch(showExampleAction())
}

const PhotoUpload = (props) => {

    const { state, count, setCount } = props

    if (!state.cardData || (state.cardData.status !== 'WAIT_FOR_PHOTO' && state.cardData.status !== 'NO_INFO' && state.cardData.status !== 'CANCELED')) { return null }

    return (
        <div className={classes.upload__wrapper}>
            {window.screen.width > 700 && (
                <>
                    <div className={classes.qr__wrapper}>
                        <QRCode
                            value={config.baseUrl + '/card-photo?cardNumber=' + state.cardData.number + '&countryCode=' + state.cardData.countryCode + '&scheme=' + state.cardData.scheme + '&locale=' + state.locale}
                            size={164} level={'Q'} />
                    </div>
                    <div className={classes.qr__text}>{strings('firstScreen.cardValid.uploadQR')}</div>
                </>
            )}
            <div className={classes.upload}>
                <div className={classes.upload__label} onClick={showExampleHandler}>
                    {strings('firstScreen.cardValid.chooseFile')}
                </div>
                {/* <label htmlFor={'upload_photo'} className={classes.upload__label}>{strings('firstScreen.cardValid.chooseFile')}</label>
                <input id={'upload_photo'} type="file" onChange={event => fileInputHandler(state, event)}
                    onClick={(e) => { e.target.value = '' }} /> */}
                {state.cardData.fileData ?
                    <img src={Done} alt={'done'} />
                    : null
                }
            </div>
            <div className={classes.button}>
                <button onClick={() => {
                    if (count !== 0) return
                    // eslint-disable-next-line no-unused-expressions
                    if (state.cardData.fileData) {
                        setCount(1)
                        uploadCardPhotoButtonHandler(state, setCount)
                        analytics().logEvent('dataInputScreen_click_upload')
                    }
                }}>
                    {strings('firstScreen.cardValid.upload')}
                    {count !== 0 &&
                        <img src={LoaderWhite} alt={'load'} height={40} />}
                </button>
            </div>
        </div>
    )
}

const fileInputHandler = async (state, event) => {
    const file = event.target.files[0]

    const fileData = await new Promise(resolve => {
        Resizer.imageFileResizer(file, 1920, 1080, 'JPEG', 80, 0, uri => { resolve(uri) }, 'base64')
    })
    dispatch(fileInputAction(state, fileData))
}

const uploadCardPhotoButtonHandler = async (state, setCount) => {
    try {
        const { number, fileData, countryCode } = state.cardData

        if (!number) {
            throw new Error('Invalid card number')
        }
        if (!fileData) {
            throw new Error('Invalid file')
        }
        reCaptchaRef.current.reset()
        const captchaToken = await reCaptchaRef.current.executeAsync()

        const body = new FormData()
        body.set('cardNumber', number)
        body.set('locale', state.locale)
        body.set('countryCode', countryCode)
        body.set('captchaToken', captchaToken)
        body.append('image', fileData)

        const response = await axios.post(config.backendUrl + '/payment-details/validate-card', body, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        dispatch(uploadCardPhotoAction(state, response))
        setCount(0)

    } catch (error) {
        // alert(error.message)
        console.log(error.response.data)
        setCount(0)
        reCaptchaRef.current.reset()
        return;
    }
}

const UniquePaymentServices = (props) => {

    const { state } = props

    const [count, setCount] = useState(0)

    if (!state.equivalentData) { return null }

    const exchangeWayInfo = state.allExchangeWays.find(way => way.exchangeWayId === state.equivalentData.exchangeWayId);
    if (exchangeWayInfo.outCurrency.type === 'FIAT') { return null }

    if (state.payway.indexOf('VISA_MC') === -1) {
        return (
            <>
                <div
                    className={state.cardValid ? classes.cardData__error : classes.cardData__wrapper}>
                    <input
                        type="text"
                        placeholder={state.payway === 'MOBILE_PHONE' || state.payway === 'QIWI' ? strings('firstScreen.phoneNumber') : strings('mobileSell.accountNumber')}
                        maxLength="16"
                        required={true}
                        value={state.cardData ? state.cardData.number : ''}
                        onChange={event => cardNumberInputHandler(state, event)}
                    />
                    <CardVerificationLogo state={state} />
                </div>
            </>
        )
    }

    return (
        <>
            <div
                className={state.cardValid ? classes.cardData__error : state.cardData ? state.cardData.status === 'INVALID_CARD_NUMBER' || state.cardData.status === 'NOT_SUPPORTED_COUNTRY' || state.cardData.status === 'CANCELED' ? classes.cardData__error : state.cardData.status === 'NO_INFO' || state.cardData.status === 'WAIT_FOR_PHOTO' ? classes.cardData__noInfo : classes.cardData__wrapper : classes.cardData__wrapper}>
                <input
                    type="text"
                    placeholder={strings('firstScreen.cardValid.cardNumber')}
                    maxLength="16"
                    required={true}
                    value={state.cardData ? state.cardData.number : ''}
                    onChange={event => cardNumberInputHandler(state, event)}
                />
                <CardVerificationLogo state={state} />
            </div>
            {state.cardValid ?
                <div className={classes.destination__error}>
                    {strings('firstScreen.cardValid.cardValid')}
                </div> : null}
            {state.cardData ?
                <div className={classes.card__status__text}
                    style={{ color: state.cardData.status === 'INVALID_CARD_NUMBER' || state.cardData.status === 'NOT_SUPPORTED_COUNTRY' || state.cardData.status === 'CANCELED' ? '#E54C4C' : state.cardData.status === 'NO_INFO' || state.cardData.status === 'WAIT_FOR_PHOTO' ? '#999999' : '#412d4b' }}>
                    {statusCard(state.cardData.status)}
                </div>
                : null}
            <PhotoUpload state={state} count={count} setCount={setCount} />
            <ReCAPTCHA
                ref={reCaptchaRef}
                size="invisible"
                sitekey={config.captchaSiteKey}
                style={{ position: 'absolute', top: '20%' }}
            />
        </>
    )
}

export default UniquePaymentServices